import React from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../routes/routes';
import Slider from "react-slick";
import { Menu, Dropdown, Space, Modal } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';

import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';

import banner_image from '../assets/images/homebanner/banner-image.png';
import lab_test from '../assets/images/icons/lab_test.svg';
import sample_collection from '../assets/images/icons/sample_collection.svg';
import get_reports from '../assets/images/icons/get_reports.svg';
import chain_logistics from '../assets/images/icons/chain_logistics.svg';
import convenient_booking from '../assets/images/icons/convenient_booking.svg';
import verified from '../assets/images/icons/verified.svg';
import certified from '../assets/images/icons/certified.svg';
import on_time_report from '../assets/images/icons/on_time_report.svg';
import testimonail1 from '../assets/images/icons/testimonail1.png';
import testimonail2 from '../assets/images/icons/testimonail2.png';
import testimonail3 from '../assets/images/icons/testimonail3.png';
import search from '../assets/images/search-icon.svg';

import Header from './Header';
import Footer from './Footer';



class home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    state = { visible: false };
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    
    render() {
        var testinomail_slider = {
            dots: true,
            infinite: true,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        const menu = (
            <Menu
              items={[
                {
                  label: <div className="current-location-box">
                            <div className="current-location-title-area">
                                <div className="current-location-title-box">
                                    <p className="current-location-title">Current Location</p>
                                </div>
                            </div>
                            <div className="location-link-box">
                                <a href="" className="location-link">Detect Using GPS</a>
                            </div>
                        </div>
                ,
                  key: '0',
                },
                {
                  label: <div className="search-location-area">
                            <div className="search-location-box">
                                <input type="text" className="search-input-field common-input-field" placeholder="Search for location" />
                            </div>
                        </div>,
                  key: '1',
                }
              ]}
            />
          );
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Home</title>
                </Helmet>
                <Header prop={this.props} />
                <div className="home-banner home-without-login">
                    <div className="banner-image-box">
                        <img src={banner_image} alt="PhleboIndia" />
                    </div>
                    <div className="banner-title">
                        <div className="container">
                            <div className="home-banner-detail-box">
                                <h1>Lab test matlab PhleboIndia!</h1>
                                <p className="banner-description">Lab test collection in <span className="weight-700"> 60 minutes.</span></p>
                                <div className="banner-dropdown-search-box-wrapper">
                                    <div className="banner-dropdown-search-area">
                                        <div className="banner-location-dropdown">
                                            <Dropdown overlay={menu} ClassName="location-dropdown" overlayClassName="location-dropdown-box" trigger={['click']}>
                                                <a onClick={(e) => e.preventDefault()}>
                                                <Space>
                                                    Select Location
                                                    <DownOutlined />
                                                </Space>
                                                </a>
                                            </Dropdown>
                                        </div>
                                        <div className="banner-search-input-box">
                                            <span className="search-icon-box">
                                                <img src={search} alt="" />
                                            </span>
                                            <input type="text" className="serach-input-field" placeholder="Search your Preferred Lab or Test" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bannerform-area">
                        <div className="form-area">
                        </div>
                    </div>
                </div>
                <div className="why-us-section section-padding dark-bg">
                    <div className="container">
                        <div className="text-center">
                            <h2 className="text-white">Why PhleboIndia?</h2>
                        </div>
                        <div className="row why-us-row">
                            <div className="col-lg-6 why-us-col">
                                <div className="why-us-custom-col">
                                    <div className="why-us-box">
                                        <div className="icon-box">
                                            <img src={convenient_booking} alt="Convenient Booking Process" />
                                        </div>
                                        <div className="detail-box">
                                            <h4 className="text-white">Convenient Booking Process</h4>
                                            <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, at aliquam proin est aliquet nam pellentesque suspendisse diam. Est a et viverra ut pellentesque gravida.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 why-us-col">
                                <div className="why-us-custom-col">
                                    <div className="why-us-box">
                                        <div className="icon-box">
                                            <img src={verified} alt="Verified & NABL Accreditated Labs" />
                                        </div>
                                        <div className="detail-box">
                                            <h4 className="text-white">Verified & NABL Accreditated Labs</h4>
                                            <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, at aliquam proin est aliquet nam pellentesque suspendisse diam. Est a et viverra ut pellentesque gravida.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 why-us-col">
                                <div className="why-us-custom-col">
                                    <div className="why-us-box">
                                        <div className="icon-box">
                                            <img src={certified} alt="Certified Phlebotomists" />
                                        </div>
                                        <div className="detail-box">
                                            <h4 className="text-white">Certified Phlebotomists</h4>
                                            <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, at aliquam proin est aliquet nam pellentesque suspendisse diam. Est a et viverra ut pellentesque gravida.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 why-us-col">
                                <div className="why-us-custom-col">
                                    <div className="why-us-box">
                                        <div className="icon-box">
                                            <img src={on_time_report} alt="On Time Reports" />
                                        </div>
                                        <div className="detail-box">
                                            <h4 className="text-white">On Time Reports</h4>
                                            <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, at aliquam proin est aliquet nam pellentesque suspendisse diam. Est a et viverra ut pellentesque gravida.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="industrial-parts-area section-padding">
                    <div className="container">
                        <div className="text-center">
                            <h2>How PhleboIndia Works</h2>
                        </div>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="industrial-parts-box">
                                    <div className="industrial-partsicon">
                                        <img src={lab_test} alt="Signup - Only takes a few seconds" className="img-fluid" />
                                    </div>
                                    <div className="industrial-partsdetail">
                                        <h4>Search and book lab test at your doorstep</h4>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi morbi amet, orci, ullamcorper.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="industrial-parts-box">
                                    <div className="industrial-partsicon">
                                        <img src={sample_collection} alt="Purchase - Fast and Streamlined" className="img-fluid" />
                                    </div>
                                    <div className="industrial-partsdetail">
                                        <h4>On time sample collection</h4>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi morbi amet, orci, ullamcorper.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="industrial-parts-box">
                                    <div className="industrial-partsicon">
                                        <img src={get_reports} alt="Delivery - Quick and Efficient " className="img-fluid" />
                                    </div>
                                    <div className="industrial-partsdetail">
                                        <h4>Get reports quickly</h4>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi morbi amet, orci, ullamcorper.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="industrial-parts-box">
                                    <div className="industrial-partsicon">
                                        <img src={chain_logistics} alt="Delivery - Quick and Efficient " className="img-fluid" />
                                    </div>
                                    <div className="industrial-partsdetail">
                                        <h4>Cold chain logistics</h4>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi morbi amet, orci, ullamcorper.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="download-app-area bg-green section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="download-app-detail">
                                    <h2 className="text-white">Book your lab tests with PhleboIndia app</h2>
                                    <div className="small-detail">
                                        <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Rhoncus pretium a aliquam proin rutrum vitae. Magna ipsum dui feugiat gravida libero amet, imperdiet.</p>
                                    </div>
                                    <div className="download-app-row">
                                        <a href="https://www.apple.com/in/app-store/" target="_blank" title="App Store" className="common-btn dark-bg">
                                            <i className="fab fa-apple"></i> App Store</a>
                                        <a href="https://play.google.com/store" target="_blank" title="Google Play" className="common-btn dark-bg">
                                            <i className="fab fa-google-play"></i> Google Play</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="customer-testimonail-section section-padding">
                    <div className="container">
                        <div className="title-box">
                            <h2 className="text-center">Our Happy Customers</h2>
                        </div>
                        <div className="slide-wrap">
                            <div className="slide-col">
                                {/* <div className="customer-testimonail-area"> */}
                                <Slider {...testinomail_slider} className="customer-testimonail-area">
                                    <div className="testimonail-box">
                                        <div className="icon-box">
                                            <img src={testimonail1} alt="Customer Testinomail" />
                                        </div>
                                        <div className="testimonail-description-box">
                                            <h6>Renish Selvasi</h6>
                                            <p>“Lorem ipsum dolor sit amet, consectetur adipiscing elit. A, id enim, vitae, morbi sed eget in sit. Tempus semper phasellus non, vitae tellus egestas eget laoreet.”</p>
                                        </div>
                                    </div>
                                    <div className="testimonail-box">
                                        <div className="icon-box">
                                            <img src={testimonail2} alt="Customer Testinomail" />
                                        </div>
                                        <div className="testimonail-description-box">
                                            <h6>Mansi Chauhan</h6>
                                            <p>“Lorem ipsum dolor sit amet, consectetur adipiscing elit. A, id enim, vitae, morbi sed eget in sit. Tempus semper phasellus non, vitae tellus egestas eget laoreet.”</p>
                                        </div>
                                    </div>
                                    <div className="testimonail-box">
                                        <div className="icon-box">
                                            <img src={testimonail3} alt="Customer Testinomail" />
                                        </div>
                                        <div className="testimonail-description-box">
                                            <h6>Jay Devmalani</h6>
                                            <p>“Lorem ipsum dolor sit amet, consectetur adipiscing elit. A, id enim, vitae, morbi sed eget in sit. Tempus semper phasellus non, vitae tellus egestas eget laoreet.”</p>
                                        </div>
                                    </div>
                                    <div className="testimonail-box">
                                        <div className="icon-box">
                                            <img src={testimonail2} alt="Customer Testinomail" />
                                        </div>
                                        <div className="testimonail-description-box">
                                            <h6>Mansi Chauhan</h6>
                                            <p>“Lorem ipsum dolor sit amet, consectetur adipiscing elit. A, id enim, vitae, morbi sed eget in sit. Tempus semper phasellus non, vitae tellus egestas eget laoreet.”</p>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer prop={this.props} />
            </>
        );
    }
};

export default home;